import Cancelled from "../cancelled/Cancelled";
import Delivered from "../delivered/Delivered";
import Ordered from "../ordered/Ordered";
import Return from "../return/Return";

const OrderHistory = () => {
  return (
    <>
      <div className="Orderer_history_list_holder">
        <Ordered type="Ordered" />

        <Delivered type={"Ordered"} />

        <Return type="Return" />

        <Cancelled />
      </div>
    </>
  );
};

export default OrderHistory;
